import type { IconProps } from '../types/IconProps.ts';
export const TruckElectric: IconProps = {
    name: 'TruckElectric',
    children: [
        `<path d="M7 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4M17 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />`,
        `<path d="M5 18H4a2 2 0 0 1-2-2v-5m12 7V6a2 2 0 0 0-2-2H8M4 2 2.13 5.74c-.05.1.04.2.14.17l2.51-.84c.1-.03.18.06.16.15L4 8.5M9 18h6M19 18h1a2 2 0 0 0 2-2v-3.54a2 2 0 0 0-.65-1.47l-3.78-3.46A2 2 0 0 0 16.22 7H14" />`,
    ]
};